import { render, staticRenderFns } from "./CompetencesEditor.vue?vue&type=template&id=72ca47d0&scoped=true&"
import script from "./CompetencesEditor.vue?vue&type=script&lang=js&"
export * from "./CompetencesEditor.vue?vue&type=script&lang=js&"
import style0 from "./CompetencesEditor.vue?vue&type=style&index=0&id=72ca47d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ca47d0",
  null
  
)

export default component.exports